import { Routes, Route, Navigate } from "react-router-dom";
import { routes } from "common/routes";
import { HomePage } from "pages/HomePage";
import {
  SaveUserMappingNaPickingPage,
  UploadUserMappingNaPickingPage,
} from "pages/NaPicking";
import {
  AllRequisitionsPage,
  RequisitionInfoPage,
  SaveStoreRequisitionPage,
  SaveUserMappingStoreRequisitionPage,
  UploadStoreRequisitionPage,
  UploadUserMappingStoreRequisitionPage,
} from "pages/StoreRequisition";
import { StoreRejectionUploadPage } from "pages/StoreRejection/StoreRejectionPage";
import { ProtectedRoute } from "./ProtectedRoute";
import { LoginPage } from "pages/LoginPage";
import { ForgotPasswordPage } from "pages/ForgotPasswordPage";
import { LoggedInLayout } from "components/AppLayout/LoggedInLayout";
import { LoggedOutLayout } from "components/AppLayout/LoggedOutLayout";
import { Suspense } from "react";
import { AppLoader } from "components/AppLoader";
import { StoreRejectionPage } from "pages/StoreRejection/StoreRejectionSavePage";
import { SavePickerRequisitionPage } from "pages/PPD/SavePickerMappingPage";
import { UploadPickerMappingStoreRequisitionPage } from "pages/PPD/UploadPickerMappingPage";
import { CronRemapUsersPage } from "pages/PPD/CronRemapUsersPage";
import UploadFifDsrPage from "pages/FIF/UploadFifDsrPage";
import SaveFifDsrPage from "pages/FIF/SaveFifDsrPage";
import { AddNewUserPage } from "pages/AdminServices/AddNewUser";
import AllStoreReturnsPage from "pages/StoreReturn/AllStoreReturn";
import StoreReturnUploadPage from "pages/StoreReturn/UploadStoreReturnMapping";
import FranchiseMappingUploadPage from "pages/FranchiseServices/FranchiseMappingUploadPage";
import { FranchiseMappingSavePage } from "pages/FranchiseServices/FranchiseMappingSavePage";
import StoreReturnViewPage from "pages/StoreReturn/StoreReturnViewPage";
import StoreReturnReceivePage from "pages/StoreReturn/StoreReturnRecievePage";
import SaveStoreReturnPage from "pages/StoreReturn/SaveStoreReturnMapping";
import OrdersPage from "../pages/PPD/OrdersPage";
import PPDViewPage from "pages/PPD/PPDViewPage";
import DeliveryOrdersPage from "../pages/PPD/DeliveryOrdersPage";
import AdminUsersPage from "../pages/AdminServices/AdminUsersPage";
import { UpdateAdminUserPage } from "pages/AdminServices/UpdateAdminUser";
import DeliveryItemViewPage from "pages/PPD/DeliveryOrderViewPage";
import VendorHomePage from "pages/VendorManagement/VendorHomePage";
import POEditPage from "pages/PO/POEditPage";
import POSavePage from "pages/PO/POSavePage";
import POUploadPage from "pages/PO/POUploadPage";
import EditVendorPage from "pages/VendorManagement/EditVendorPage";
import NewVendorPage from "pages/VendorManagement/NewVendorPage";
import ViewVendorPage from "pages/VendorManagement/ViewVendorPage";
import VendorAmendmentsPage from "pages/VendorManagement/VendorAmendmentsPage";
import VendorAmendmentDetailPage from "pages/VendorManagement/VendorAmendmentDetailPage";
import AllPOPage from "pages/PO/AllPOPage";
import CompletePOBillingPage from "pages/PO/CompletePOBillingPage";
import GrnPage from "pages/PO/GrnPage";
import POViewPage from "pages/PO/POViewPage";
import GRNViewPage from "pages/PO/GRNViewPage";
import POReceivePage from "pages/PO/POReceivePage";
import FranchiseListing from "pages/FranchiseServices/FranchiseCatalogueListing";
import { SaveProjectedSrPage } from "pages/AdminServices/SaveProjectedSr";
import { UploadPProcessingSrPage } from "pages/AdminServices/UploadProjectedSr";
import { WarehouseSelectionPage } from "pages/WarehouseSelectionPage";
import { UploadStockExchangePage } from "pages/StockExchange/UploadStockExchange";
import AllSentStockExchangesPage from "pages/StockExchange/AllSentStockExchanges";
import STViewPage from "pages/StockExchange/ViewStockExchange";
import { SaveStockExchangePage } from "pages/StockExchange/SaveStockExchange";
import AllReceivedStockExchangesPage from "pages/StockExchange/AllReceivedExchanges";
import { AllRequisitionsDispatchedPage } from "pages/StoreRequisition/AllDispatchedRequisitionsPage";
import { DispatchedRequisitionInfoPage } from "pages/StoreRequisition/DispatchedRequisitionInfoPage";
import { UploadInternalStockExchangePage } from "pages/StockInternelExchange/UploadInternelStockExchange";
import { SaveInternalStockExchangePage } from "pages/StockInternelExchange/SaveInternelStockExchange";
import { UploadUserDayMappingPage } from "pages/AdminServices/UploadUserDayMapping";
import { SaveUserDayMapping } from "pages/AdminServices/SaveUserDayMapping";
import { SuggestedPickingPage } from "pages/StoreRequisition/SuggestedPickingPage";
import QualityCheckPage from "pages/QualityCheck/AllQualityCheck";
import { SaveMiddleMileMappjngPage, UploadMiddleMileMappingPage } from "pages/MiddleMileServices";
import AllMiddleMilesPage from "pages/MiddleMileServices/AllMiddleMilesPage";
import AllCashCollectionsPage from "pages/CashCollectionServices/AllCashCollections";
import PricingOverrideUploadPage from "pages/FranchiseServices/PricingOverrideUploadPage";
import { PricingOverrideSavePage } from "pages/FranchiseServices/PricingOverrideSavePage";
import { AddNewWhSkuPage } from "pages/FranchiseServices/AddNewWhSku";
import CategoryPricingUploadPage from "pages/FranchiseServices/CategoryPricingUploadPage";
import { CatagoryPricingSavePage } from "pages/FranchiseServices/CategoryPricingSavePage";
import MiddleMileTrackingPage from "pages/MiddleMileServices/MiddleMileTrackingPage";
import { SaveStoreSecondaryPickingPage } from "pages/StoreRequisition/SaveStoreSecondaryPickingPage";
import { UploadStoreSecondaryPicking } from "pages/StoreRequisition/UploadStoreSecondaryPickingPage";
import { UploadHoldAdjustmentPage } from "pages/StockExchange/UploadHoldAdjustment";
import { SaveHoldExchangePage } from "pages/StockExchange/SaveHoldAdjustment";
import CreateStoreReturnPage from "pages/StoreReturn/AllCreateRequests";
import ViewCreateStoreReturnPage from "pages/StoreReturn/ViewCreateRequest";
import InventoryAdjUploadPage from "pages/FranchiseServices/InventoryAdjustment/InventoryAdjustmentUpload";
import { InventoryAdjSavePage } from "pages/FranchiseServices/InventoryAdjustment/InventoryAdjustmentSavePage";
import POBillingRateUploadPage from "pages/PO/POBillingUpload";
import POSaveBillingRatePage from "pages/PO/POSaveBillingRatePage";
import { UploadUserMappingFaPickingPage } from "pages/NaPicking/UploadFAUserMappingPage";
import { SaveUserMappingFAPickingPage } from "pages/NaPicking/SaveFAUserMappingPage";
import MergeRoutesPage from "pages/MiddleMileServices/MergeRoutesPage";
import { UploadClusterStoreMappingPage } from "pages/ClusterServices/ClusterStoreMappingUploadPage";
import { SaveClusterStoreMappingPage } from "pages/ClusterServices/ClusterStoreMappingSaveUploadPage";
import { UploadClusterAMMappingPage } from "pages/ClusterServices/ClusterAMMappingUploadPage";
import { SaveClusterAmMappingPage } from "pages/ClusterServices/ClusterAMMappingSaveUploadPage";
import { ConsumerClusterSavePage } from "pages/ConsumerServices/ConsumerClusterUpload/ConsumerClusterSavePage";
import { UploadConsumerClusterPage } from "pages/ConsumerServices/ConsumerClusterUpload/ConsumerClusterUploadPage";
import { SaveConsumerSocietyClusterPage } from "pages/ConsumerServices/ConsumerClusterSociety/ConsumerClusterSocietySavePage";
import { UploadConsumerSocietyClusterPage } from "pages/ConsumerServices/ConsumerClusterSociety/ConsumerClusterSocietyUploadPage";
import { UploadVendorWarehousePage } from "pages/AdminServices/UploadVendorWarehouseMapping";
import { SaveVendorWarehousePage } from "pages/AdminServices/SaveVendorWarehouseMapping";
import EditTablePage from "pages/PPD/PPDTableConfigPage";
import StoreConfigsPage from "pages/PPD/StoreConfigsPage";
import EditStoreConfigPage from "pages/PPD/EditStoreConfigPage";
import NewStoreConfigPage from "pages/PPD/NewStoreConfigPage";
import { CreateNewSocietyPage } from "pages/SocietyServices/CreateSocietyPage";
import SocietyListingPage from "pages/SocietyServices/SocietyListingPage";
import ApproveSocietyListingPage from "pages/SocietyServices/ApproveSocietyListingPage";
import SocietyAmendmentDetailPage from "pages/SocietyServices/SocietyAmendmentDetailPage";
import MergeSocietyPage from "pages/SocietyServices/MergeSocietyPage";
import DelayRequestListingPage from "pages/DelayRequetsPage/DelayRequestsListingPage";
import UploadSocietySequencePage from "pages/AdminServices/UploadSocietySequencePage";
import { SaveSocietySequenceMapping } from "pages/AdminServices/SaveSocietySequencePage";
import UploadDynamicClusteringPage from "pages/AdminServices/UploadDynamicClusteringPage";
import { SaveDynamicClusteringMapping } from "pages/AdminServices/SaveDynamicClusteringPage";
import AllSplitSkusPage from "pages/SplitSkuServices/SplitSkuListingPage";
import SplitSKUDetailsPage from "pages/SplitSkuServices/SplitSkuDetailPage";
import UploadMarginTrackingPage from "pages/PO/UploadMarginTrackingPage";
import MarginTrackingSavePage from "pages/PO/MarginTrackingSavePage";
import { GenerateSequencePage } from "pages/PPD/GenerateSequencePage";
import AvailableOrdersPage from "pages/PPD/AvailableOrdersPage";
import AvailableOrdersConfigPage from "pages/PPD/AvailableOrdersConfigPage";
import { PidgePage } from "pages/PPD/PidgePage";
import MarkHoldOrdersPage from "pages/PPD/MarkHoldOrdersPage";
import DropPointsPage from "pages/PPD/DropPointsPage";
import ItemReturnPage from "pages/PPD/ItemReturnPage";
import PidgeSlotConfigsPage from "pages/Pidge/PidgeSlotConfigsPage";
import PurchaseCodesPage from "pages/PO/PurchaseCodesPage";
import PurchaseCodeEditPage from "pages/PO/PurchaseCodeEditPage";
import PurchaseCodeAmendmentsPage from "pages/PO/PurchaseCodeAmendmentsPage";
import PurchaseCodeAmendmentDetailPage from "pages/PO/PurchaseCodeAmendmentDetailPage";
import VendorItemsPage from "pages/PO/VendorItemsPage";
import VendorItemsMappingPage from "pages/PO/VendorItemsMappingPage";
import PurchaseIndentUploadPage from "pages/PurchaseIndent/PurchaseIndentUploadPage";
import PurchaseIndentSavePage from "pages/PurchaseIndent/PurchaseIndentSavePage";
import PurchaseIndentListingPage from "pages/PurchaseIndent/PurchaseIndentListingPage";
import DispatchInvoicePage from "pages/PO/DispatchInvoicePage";
import PurchaseIndentCreatePage from "pages/PurchaseIndent/PurchaseIndentCreatePage";
import VendorAssignmentUploadPage from "pages/PurchaseIndent/VendorAssignmentUploadPage";
import VendorAssignmentSavePage from "pages/PurchaseIndent/VendorAssignmentSavePage";
import UserCheckoutQRPage from "pages/PartnerServices/UserCheckoutQRPage";
import OnboardingDetailsPage from "pages/PartnerServices/OnboardingDetailsPage";
import UploadOnboardingDetailsPage from "pages/PartnerServices/UploadOnboardingDetailsPage";
import UploadGigPayoutsPage from "pages/PartnerServices/UploadGigPayoutsPage";
import SaveGigPayoutsPage from "pages/PartnerServices/SaveGigPayoutsPage";
import EarningPayoutsPage from "pages/PartnerServices/EarningPayoutsPage";
import UploadEarningPayoutsPage from "pages/PartnerServices/UploadEarningPayoutsPage";
import SaveEarningPayoutsPage from "pages/PartnerServices/SaveEarningPayoutsPage";
import UploadAlterEarningsPage from "pages/PartnerServices/UploadAlterEarningsPage";
import SaveAlterEarningsPage from "pages/PartnerServices/SaveAlterEarningsPage";
import ProcessEarningsPage from "pages/PartnerServices/ProcessEarningsPage";
import {
  UploadAttendanceRosterPage,
  SaveAttendanceRosterPage,
  ViewAttendanceRosterPage,
} from "pages/AttendanceRoster";
import {
  ViewUserTableRackMappingPage,
  RackUsersMappingPage,
} from "pages/UserTableRackMapping";
import DeliveryLoginQRPage from "pages/DeliveryServices/DeliveryLoginQRPage";
import PlatformConfigListingPage from "pages/PlatformConfigs/PlatformConfigListingPage";
import PlatformConfigDetailPage from "pages/PlatformConfigs/PlatformConfigDetailPage";
import PlatformConfigCreatePage from "pages/PlatformConfigs/PlatformConfigCreatePage";

const WhOnboardingDetailsPage = () => <OnboardingDetailsPage variant="wh" />;
const WhUploadGigPayoutsPage = () => <UploadGigPayoutsPage variant="wh" />;
const WhSaveGigPayoutsPage = () => <SaveGigPayoutsPage variant="wh" />;
const WhEarningPayoutsPage = () => <EarningPayoutsPage variant="wh" />;
const WhUploadEarningPayoutsPage = () => <UploadEarningPayoutsPage variant="wh" />;
const WhSaveEarningPayoutsPage = () => <SaveEarningPayoutsPage variant="wh" />;
const WhUploadAlterEarningsPage = () => <UploadAlterEarningsPage variant="wh" />;
const WhSaveAlterEarningsPage = () => <SaveAlterEarningsPage variant="wh" />;
const WhProcessEarningsPage = () => <ProcessEarningsPage variant="wh" />;

export const AppRoutes = () => (
  <Suspense fallback={<AppLoader />}>
    <Routes>
      <Route element={<LoggedInLayout />}>
        <Route
          path="/"
          element={<Navigate to={`${routes.HOME}`} replace />}
        >
        </Route>
        <Route
          path={routes.HOME}
          element={<ProtectedRoute component={HomePage} />}
        />
        <Route
          path={`${routes.STORE_REQUISITION.SELF}/:reqId`}
          element={<ProtectedRoute component={RequisitionInfoPage} />}
        />
        <Route
          path={`${routes.STORE_REQUISITION.ALL_DISPATCHED}/:reqId`}
          element={<ProtectedRoute component={DispatchedRequisitionInfoPage} />}
        />
        <Route
          path={`${routes.STORE_REQUISITION.ALL_SPLIT_SKU}`}
          element={<ProtectedRoute component={AllSplitSkusPage} />}
        />
        <Route
          path={`${routes.STORE_REQUISITION.ALL_SPLIT_SKU}/:id`}
          element={<ProtectedRoute component={SplitSKUDetailsPage} />}
        />
        <Route
          path={`${routes.STORE_REQUISITION.CREATE_SPLIT_SKU}`}
          element={<ProtectedRoute component={SplitSKUDetailsPage} />}
        />
        <Route
          path={routes.STORE_REQUISITION.ALL}
          element={<ProtectedRoute component={AllRequisitionsPage} />}
        />
        <Route
          path={routes.STORE_REQUISITION.UPLOAD}
          element={<ProtectedRoute component={UploadStoreRequisitionPage} />}
        />
        <Route
          path={routes.STORE_REQUISITION.SAVE}
          element={<ProtectedRoute component={SaveStoreRequisitionPage} />}
        />
        <Route
          path={routes.STORE_REQUISITION.ALL_DISPATCHED}
          element={<ProtectedRoute component={AllRequisitionsDispatchedPage} />}
        />
        <Route
          path={routes.STORE_REQUISITION.USER_MAPPING_UPLOAD}
          element={
            <ProtectedRoute component={UploadUserMappingStoreRequisitionPage} />
          }
        />
        <Route
          path={routes.STORE_REQUISITION.SUGGESTED_PICKING}
          element={
            <ProtectedRoute component={SuggestedPickingPage} />
          }
        />

        <Route
          path={routes.FIF.UPLOAD_DSR}
          element={
            <ProtectedRoute component={UploadFifDsrPage} />
          }
        />

        <Route
          path={routes.FIF.SAVE_DSR}
          element={
            <ProtectedRoute component={SaveFifDsrPage} />
          }
        />

        <Route
          path={routes.PPD.UPLOAD}
          element={
            <ProtectedRoute component={UploadPickerMappingStoreRequisitionPage} />
          }
        />
        <Route
          path={routes.STORE_REQUISITION.USER_MAPPING_SAVE}
          element={
            <ProtectedRoute component={SaveUserMappingStoreRequisitionPage} />
          }
        />
        <Route
          path={routes.STORE_REQUISITION.SEC_PICKING_SAVE}
          element={
            <ProtectedRoute component={SaveStoreSecondaryPickingPage} />
          }
        />
        <Route
          path={routes.STORE_REQUISITION.SEC_PICKING_UPLOAD}
          element={
            <ProtectedRoute component={UploadStoreSecondaryPicking} />
          }
        />
        <Route
          path={routes.PPD.SAVE}
          element={
            <ProtectedRoute component={SavePickerRequisitionPage} />
          }
        />
        <Route
          path={routes.PO.UPLOAD_BILLING_RATE}
          element={
            <ProtectedRoute component={POBillingRateUploadPage} />
          }
        />
        <Route
          path={routes.PO.SAVE_BILLING_RATE}
          element={
            <ProtectedRoute component={POSaveBillingRatePage} />
          }
        />
        <Route
          path={routes.PPD.CRON_REMAP_USERS}
          element={
            <ProtectedRoute component={CronRemapUsersPage} />
          }
        />
        <Route
          path={routes.PPD.ORDERS}
          element={
            <ProtectedRoute component={OrdersPage} />
          }
        />
        <Route
          path={routes.PPD.VIEW}
          element={
            <ProtectedRoute component={PPDViewPage} />
          }
        />
        <Route
          path={routes.PPD.DELIVERY_ORDERS}
          element={
            <ProtectedRoute component={DeliveryOrdersPage} />
          }
        />
        <Route
          path={routes.PPD.VIEW_DELIVERY_ORDERS}
          element={
            <ProtectedRoute component={DeliveryItemViewPage} />
          }
        />
        <Route
          path={routes.SR_USER_MAPPING.NA_USER_MAPPING_UPLOAD}
          element={
            <ProtectedRoute component={UploadUserMappingNaPickingPage} />
          }
        />
        <Route
          path={routes.SR_USER_MAPPING.NA_USER_MAPPING_SAVE}
          element={<ProtectedRoute component={SaveUserMappingNaPickingPage} />}
        />
        <Route
          path={routes.SR_USER_MAPPING.FA_USER_MAPPING_UPLOAD}
          element={
            <ProtectedRoute component={UploadUserMappingFaPickingPage} />
          }
        />
        <Route
          path={routes.SR_USER_MAPPING.FA_USER_MAPPING_SAVE}
          element={<ProtectedRoute component={SaveUserMappingFAPickingPage} />}
        />
        <Route
          path={routes.MIDDLE_MILE.MIDDLE_MILE_UPLOAD}
          element={
            <ProtectedRoute component={UploadMiddleMileMappingPage} />
          }
        />
        <Route
          path={routes.MIDDLE_MILE.MIDDLE_MILE_SAVE}
          element={<ProtectedRoute component={SaveMiddleMileMappjngPage} />}
        />
        <Route
          path={routes.MIDDLE_MILE.ALL_MIDDLE_MILE}
          element={<ProtectedRoute component={AllMiddleMilesPage} />}
        />
        <Route
          path={routes.MIDDLE_MILE.TRACKING_INFO}
          element={<ProtectedRoute component={MiddleMileTrackingPage} />}
        />        
        <Route
          path={routes.MIDDLE_MILE.MERGE_ROUTES}
          element={<ProtectedRoute component={MergeRoutesPage} />}
        />
        <Route
          path={routes.STORE_REJECTION.INVENTORY_REJECTION_UPLOAD}
          element={<ProtectedRoute component={StoreRejectionUploadPage} />}
        />
        <Route
          path={routes.STORE_REJECTION.INVENTORY_REJECTION_SAVE}
          element={<ProtectedRoute component={StoreRejectionPage} />}
        />

        <Route
          path={routes.STORE_RETURN.ALL}
          element={<ProtectedRoute component={AllStoreReturnsPage} />}
        />

        <Route
          path={routes.STORE_RETURN.STORE_RETURN}
          element={<ProtectedRoute component={StoreReturnViewPage} />}
        />

        <Route
          path={routes.STORE_RETURN.RECEIVE}
          element={<ProtectedRoute component={StoreReturnReceivePage} />}
        />

        <Route
          path={routes.STORE_RETURN.UPLOAD}
          element={<ProtectedRoute component={StoreReturnUploadPage} />}
        />

        <Route
          path={routes.STORE_RETURN.SAVE}
          element={<ProtectedRoute component={SaveStoreReturnPage} />}
        />

        <Route
          path={routes.STORE_RETURN.CREATE_SR_REQUESTS}
          element={<ProtectedRoute component={CreateStoreReturnPage} />}
        />
        
        <Route
          path={routes.STORE_RETURN.CREATE_SR_REQUESTS_DETAILS}
          element={<ProtectedRoute component={ViewCreateStoreReturnPage} />}
        />

        <Route
          path={routes.ADMIN_SERVICES.ADD_NEW_USER}
          element={<ProtectedRoute component={AddNewUserPage} />}
        />
      
        <Route
          path={routes.ADMIN_SERVICES.CREATE_SOCIETY}
          element={<ProtectedRoute component={CreateNewSocietyPage} />}
        />
        
        <Route
          path={routes.ADMIN_SERVICES.SOCIETY}
          element={<ProtectedRoute component={SocietyListingPage} />}
        />
        
        <Route
          path={routes.ADMIN_SERVICES.UPDATE_SOCIETY}
          element={<ProtectedRoute component={CreateNewSocietyPage} />}
        />
        
        <Route
          path={routes.ADMIN_SERVICES.UPLOAD_SOCIETY_SEQUENCE}
          element={<ProtectedRoute component={UploadSocietySequencePage} />}
        />
        
        <Route
          path={routes.ADMIN_SERVICES.SAVE_SOCIETY_SEQUENCE}
          element={<ProtectedRoute component={SaveSocietySequenceMapping} />}
        />

        <Route
          path={routes.ADMIN_SERVICES.UPLOAD_DYNAMIC_CLUSTERING}
          element={<ProtectedRoute component={UploadDynamicClusteringPage} />}
        />

        <Route
          path={routes.ADMIN_SERVICES.SAVE_DYNAMIC_CLUSTERING}
          element={<ProtectedRoute component={SaveDynamicClusteringMapping} />}
        />

        <Route
          path={routes.CLUSTER_SOCIETY.GET_DELAY_REQUEST}
          element={<ProtectedRoute component={DelayRequestListingPage} />}
        />

        <Route
          path={routes.CLUSTER_SOCIETY.MERGE_SOCIETY}
          element={<ProtectedRoute component={MergeSocietyPage} />}
        />

        <Route
          path={routes.CLUSTER_SOCIETY.SOCIETY_AMENDMENTS}
          element={<ProtectedRoute component={ApproveSocietyListingPage} />}
        />

        <Route
          path={routes.CLUSTER_SOCIETY.SOCIETY_AMENDMENT_DETAIL}
          element={<ProtectedRoute component={SocietyAmendmentDetailPage} />}
        />

        <Route
          path={routes.ADMIN_SERVICES.ADMIN_USERS}
          element={<ProtectedRoute component={AdminUsersPage} />}
        />

        <Route
          path={routes.ADMIN_SERVICES.UPDATE_ADMIN}
          element={<ProtectedRoute component={UpdateAdminUserPage} />}
        />
        <Route
          path={routes.PROCUREMENT.UPLOAD_PROJECTED_SR}
          element={<ProtectedRoute component={UploadPProcessingSrPage} />}
        />
        <Route
          path={routes.PROCUREMENT.SAVE_PROJECTED_SR}
          element={<ProtectedRoute component={SaveProjectedSrPage} />}
        />
        <Route
          path={routes.PROCUREMENT.UPLOAD_VENDOR_WAREHOUSE_MAPPING}
          element={<ProtectedRoute component={UploadVendorWarehousePage} />}
        />
        <Route
          path={routes.PROCUREMENT.SAVE_VENDOR_WAREHOUSE_MAPPING}
          element={<ProtectedRoute component={SaveVendorWarehousePage} />}
        />

        <Route
          path={routes.FRANCHISE.UPLOAD_PRICING_OVERRIDE}
          element={<ProtectedRoute component={PricingOverrideUploadPage} />}
        />
        <Route
          path={routes.FRANCHISE.SAVE_PRICING_OVERRIDE}
          element={<ProtectedRoute component={PricingOverrideSavePage} />}
        />
        <Route
          path={routes.FRANCHISE.UPLOAD_CATEGORY_PRICING}
          element={<ProtectedRoute component={CategoryPricingUploadPage} />}
        />  
        <Route
          path={routes.FRANCHISE.SAVE_CATEGORY_PRICING}
          element={<ProtectedRoute component={CatagoryPricingSavePage} />}
        />
        <Route
          path={routes.FRANCHISE.UPLOAD_INVENTORY_ADJUSTMENT}
          element={<ProtectedRoute component={InventoryAdjUploadPage} />}
        />  
        <Route
          path={routes.FRANCHISE.SAVE_INVENTORY_ADJUSTMENT}
          element={<ProtectedRoute component={InventoryAdjSavePage} />}
        />
        <Route
          path={routes.FRANCHISE.UPLOAD}
          element={<ProtectedRoute component={FranchiseMappingUploadPage} />}
        />
        <Route
          path={routes.FRANCHISE.SAVE}
          element={<ProtectedRoute component={FranchiseMappingSavePage} />}
        />
        <Route
          path={routes.FRANCHISE.ALL}
          element={<ProtectedRoute component={FranchiseListing} />}
        />
        <Route
          path={routes.INTERNAL_STOCK_EXCHANGE.UPLOAD}
          element={<ProtectedRoute component={UploadInternalStockExchangePage} />}
        />
        <Route
          path={routes.INTERNAL_STOCK_EXCHANGE.SAVE}
          element={<ProtectedRoute component={SaveInternalStockExchangePage} />}
        />
        <Route
          path={routes.STOCK_EXCHANGE.UPLOAD}
          element={<ProtectedRoute component={UploadStockExchangePage} />}
        />
        <Route
          path={routes.STOCK_EXCHANGE.SAVE}
          element={<ProtectedRoute component={SaveStockExchangePage} />}
        />
        <Route
          path={routes.STOCK_EXCHANGE.UPLOAD_HOLD}
          element={<ProtectedRoute component={UploadHoldAdjustmentPage} />}
        />
        <Route
          path={routes.STOCK_EXCHANGE.SAVE_HOLD}
          element={<ProtectedRoute component={SaveHoldExchangePage} />}
        />

        <Route
          path={routes.USER_SERVICES.UPLOAD_USER_DAY_MAPPING}
          element={<ProtectedRoute component={UploadUserDayMappingPage} />}
        />
        <Route
          path={routes.USER_SERVICES.SAVE_USER_DAY_MAPPING}
          element={<ProtectedRoute component={SaveUserDayMapping} />}
        />
        <Route
          path={routes.STOCK_EXCHANGE.SENT}
          element={<ProtectedRoute component={AllSentStockExchangesPage} />}
        />
        <Route
          path={routes.STOCK_EXCHANGE.RECEIVED}
          element={<ProtectedRoute component={AllReceivedStockExchangesPage} />}
        />
        <Route
          path={routes.STOCK_EXCHANGE.VIEW}
          element={<ProtectedRoute component={STViewPage} />}
        />
        <Route
          path={routes.STOCK_EXCHANGE.VIEW_RECEIVED}
          element={<ProtectedRoute component={STViewPage} />}
        />
        <Route
          path={routes.QUALITY_CHECK.ALL}
          element={<ProtectedRoute component={QualityCheckPage} />}
        />
        <Route
          path={routes.CASH_COLLECTION.ALL}
          element={<ProtectedRoute component={AllCashCollectionsPage} />}
        />
        {/**
         * Lazy Loaded Routes
         */}
        <Route
          path={routes.VENDOR.ALL}
          element={<ProtectedRoute component={VendorHomePage} />}
        />
        <Route
          path={routes.VENDOR.NEW}
          element={<ProtectedRoute component={NewVendorPage} />}
        />
        <Route
          path={routes.VENDOR.EDIT}
          element={<ProtectedRoute component={EditVendorPage} />}
        />
        <Route
          path={routes.VENDOR.VIEW}
          element={<ProtectedRoute component={ViewVendorPage} />}
        />
        <Route
          path={routes.VENDOR.AMENDMENTS}
          element={<ProtectedRoute component={VendorAmendmentsPage} />}
        />
        <Route
          path={routes.VENDOR.AMENDMENT_DETAIL}
          element={<ProtectedRoute component={VendorAmendmentDetailPage} />}
        />
        <Route
          path={routes.PO.UPLOAD}
          element={<ProtectedRoute component={POUploadPage} />}
        />
        <Route
          path={routes.PO.SAVE}
          element={<ProtectedRoute component={POSavePage} />}
        />
        <Route
          path={routes.PO.EDIT}
          element={<ProtectedRoute component={POEditPage} />}
        />
        <Route
          path={routes.PO.UPLOAD_MARGIN_TRACKING}
          element={<ProtectedRoute component={UploadMarginTrackingPage} />}
        />
         <Route
          path={routes.PO.SAVE_MARGIN_TRACKING}
          element={<ProtectedRoute component={MarginTrackingSavePage} />}
        />
        <Route
          path={routes.PO.PURCHASE_CODES}
          element={<ProtectedRoute component={PurchaseCodesPage} />}
        />
        <Route
          path={routes.PO.CREATE_PURCHASE_CODE}
          element={<ProtectedRoute component={PurchaseCodeEditPage} />}
        />
        <Route
          path={routes.PO.PURCHASE_CODE_AMENDMENTS}
          element={<ProtectedRoute component={PurchaseCodeAmendmentsPage} />}
        />
        <Route
          path={routes.PO.PURCHASE_CODE_AMENDMENT_DETAIL}
          element={<ProtectedRoute component={PurchaseCodeAmendmentDetailPage} />}
        />
        <Route
          path={routes.PO.VENDOR_ITEMS}
          element={<ProtectedRoute component={VendorItemsPage} />}
        />
        <Route
          path={routes.PO.VENDOR_ITEMS_MAPPING}
          element={<ProtectedRoute component={VendorItemsMappingPage} />}
        />
        <Route
          path={routes.PO.GRN}
          element={<ProtectedRoute component={GrnPage} />}
        />
        <Route
          path={routes.PO.PO_REQUESTS}
          element={<ProtectedRoute component={AllPOPage} />}
        />
        <Route
          path={routes.PO.COMPLETE_BILLING}
          element={<ProtectedRoute component={CompletePOBillingPage} />}
        />
        <Route
          path={routes.PO.VIEW_PO_REQUEST}
          element={<ProtectedRoute component={POViewPage} />}
        />
        <Route
          path={routes.PO.PO}
          element={<ProtectedRoute component={GRNViewPage} />}
        />
        <Route
          path={routes.PO.RECEIVE}
          element={<ProtectedRoute component={POReceivePage} />}
        />
        <Route
          path={routes.PO.SORTING_RTV}
          element={<ProtectedRoute component={POReceivePage} />}
        />
        <Route
          path={routes.FRANCHISE.ADD_NEW_WH_SKU}
          element={<ProtectedRoute component={AddNewWhSkuPage} />}
        />
        <Route
          path={routes.CLUSTER_SERVICE.UPLOAD_CLUSTER_STORE_MAPPING}
          element={
            <ProtectedRoute component={UploadClusterStoreMappingPage} />
          }
        />
        <Route
          path={routes.CLUSTER_SERVICE.SAVE_CLUSTER_STORE_MAPPING}
          element={<ProtectedRoute component={SaveClusterStoreMappingPage} />}
        />
        <Route
          path={routes.CLUSTER_SERVICE.UPLOAD_CLUSTER_AM_MAPPING}
          element={
            <ProtectedRoute component={UploadClusterAMMappingPage} />
          }
        />
        <Route
          path={routes.CLUSTER_SERVICE.SAVE_CLUSTER_AM_MAPPING}
          element={<ProtectedRoute component={SaveClusterAmMappingPage} />}
        />
        <Route
          path={routes.CONSUMER_SERVICE.UPLOAD_CLUSTER_MAPPING}
          element={
            <ProtectedRoute component={UploadConsumerClusterPage} />
          }
        />
        <Route
          path={routes.CONSUMER_SERVICE.SAVE_CLUSTER_MAPPING}
          element={<ProtectedRoute component={ConsumerClusterSavePage} />}
        />
        <Route
          path={routes.CONSUMER_SERVICE.UPLOAD_CLUSTER_SOCIETY_MAPPING}
          element={
            <ProtectedRoute component={UploadConsumerSocietyClusterPage} />
          }
        />
        <Route
          path={routes.CONSUMER_SERVICE.SAVE_CLUSTER_SOCIETY_MAPPING}
          element={<ProtectedRoute component={SaveConsumerSocietyClusterPage} />}
        />
        
        <Route
          path={routes.PPD.VIEW_TABLE}
          element={<ProtectedRoute component={EditTablePage} />}
        />
        <Route
          path={routes.PPD.STORE_CONFIGS}
          element={<ProtectedRoute component={StoreConfigsPage} />}
        />
        <Route
          path={routes.PPD.NEW_STORE_CONFIG}
          element={<ProtectedRoute component={NewStoreConfigPage} />}
        />
        <Route
          path={routes.PPD.EDIT_STORE_CONFIG}
          element={<ProtectedRoute component={EditStoreConfigPage} />}
        />
        <Route
          path={routes.PPD.GENERATE_SEQUENCE}
          element={<ProtectedRoute component={GenerateSequencePage} />}
        />
        <Route
          path={routes.PPD.AVAILABLE_ORDERS}
          element={<ProtectedRoute component={AvailableOrdersPage} />}
        />
        <Route
          path={routes.PPD.AVAILABLE_ORDERS_CONFIG}
          element={<ProtectedRoute component={AvailableOrdersConfigPage} />}
        />
        <Route
          path={routes.PPD.PIDGE}
          element={<ProtectedRoute component={PidgePage} />}
        />
        <Route
          path={routes.PPD.MARK_HOLD_ORDERS}
          element={<ProtectedRoute component={MarkHoldOrdersPage} />}
        />
        <Route
          path={routes.PPD.DROP_POINTS}
          element={<ProtectedRoute component={DropPointsPage} />}
        />
        <Route
          path={routes.PPD.ITEM_RETURN}
          element={<ProtectedRoute component={ItemReturnPage} />}
        />
        <Route
          path={routes.PIDGE.SLOT_CONFIGS}
          element={<ProtectedRoute component={PidgeSlotConfigsPage} />}
        />
        <Route
          path={routes.PURCHASE_INDENT.ALL}
          element={<ProtectedRoute component={PurchaseIndentListingPage} />}
        />
        <Route
          path={routes.PURCHASE_INDENT.CREATE}
          element={<ProtectedRoute component={PurchaseIndentCreatePage} />}
        />
        <Route
          path={routes.PURCHASE_INDENT.UPLOAD}
          element={<ProtectedRoute component={PurchaseIndentUploadPage} />}
        />
        <Route
          path={routes.PURCHASE_INDENT.SAVE}
          element={<ProtectedRoute component={PurchaseIndentSavePage} />}
        />
        <Route
          path={routes.PURCHASE_INDENT.UPLOAD_VENDOR_ASSIGNMENT}
          element={<ProtectedRoute component={VendorAssignmentUploadPage} />}
        />
        <Route
          path={routes.PURCHASE_INDENT.SAVE_VENDOR_ASSIGNMENT}
          element={<ProtectedRoute component={VendorAssignmentSavePage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.USER_CHECKOUT_QR}
          element={<ProtectedRoute component={UserCheckoutQRPage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.ONBOARDING_DETAILS}
          element={<ProtectedRoute component={OnboardingDetailsPage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.UPLOAD_ONBOARDING_DETAILS}
          element={<ProtectedRoute component={UploadOnboardingDetailsPage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.UPLOAD_GIG_PAYOUTS}
          element={<ProtectedRoute component={UploadGigPayoutsPage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.SAVE_GIG_PAYOUTS}
          element={<ProtectedRoute component={SaveGigPayoutsPage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.EARNING_PAYOUTS}
          element={<ProtectedRoute component={EarningPayoutsPage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.UPLOAD_EARNING_PAYOUTS}
          element={<ProtectedRoute component={UploadEarningPayoutsPage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.SAVE_EARNING_PAYOUTS}
          element={<ProtectedRoute component={SaveEarningPayoutsPage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.UPLOAD_ALTER_EARNINGS}
          element={<ProtectedRoute component={UploadAlterEarningsPage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.SAVE_ALTER_EARNINGS}
          element={<ProtectedRoute component={SaveAlterEarningsPage} />}
        />
        <Route
          path={routes.PARTNER_SERVICES.PROCESS_EARNINGS}
          element={<ProtectedRoute component={ProcessEarningsPage} />}
        />
        <Route
          path={routes.WH_PARTNER_SERVICES.ONBOARDING_DETAILS}
          element={<ProtectedRoute component={WhOnboardingDetailsPage} />}
        />
        <Route
          path={routes.WH_PARTNER_SERVICES.UPLOAD_GIG_PAYOUTS}
          element={<ProtectedRoute component={WhUploadGigPayoutsPage} />}
        />
        <Route
          path={routes.WH_PARTNER_SERVICES.SAVE_GIG_PAYOUTS}
          element={<ProtectedRoute component={WhSaveGigPayoutsPage} />}
        />
        <Route
          path={routes.WH_PARTNER_SERVICES.EARNING_PAYOUTS}
          element={<ProtectedRoute component={WhEarningPayoutsPage} />}
        />
        <Route
          path={routes.WH_PARTNER_SERVICES.UPLOAD_EARNING_PAYOUTS}
          element={<ProtectedRoute component={WhUploadEarningPayoutsPage} />}
        />
        <Route
          path={routes.WH_PARTNER_SERVICES.SAVE_EARNING_PAYOUTS}
          element={<ProtectedRoute component={WhSaveEarningPayoutsPage} />}
        />
        <Route
          path={routes.WH_PARTNER_SERVICES.UPLOAD_ALTER_EARNINGS}
          element={<ProtectedRoute component={WhUploadAlterEarningsPage} />}
        />
        <Route
          path={routes.WH_PARTNER_SERVICES.SAVE_ALTER_EARNINGS}
          element={<ProtectedRoute component={WhSaveAlterEarningsPage} />}
        />
        <Route
          path={routes.WH_PARTNER_SERVICES.PROCESS_EARNINGS}
          element={<ProtectedRoute component={WhProcessEarningsPage} />}
        />
        <Route
          path={routes.ATTENDANCE_ROSTER.UPLOAD}
          element={<ProtectedRoute component={UploadAttendanceRosterPage} />}
        />
        <Route
          path={routes.ATTENDANCE_ROSTER.SAVE}
          element={<ProtectedRoute component={SaveAttendanceRosterPage} />}
        />
        <Route
          path={routes.ATTENDANCE_ROSTER.VIEW}
          element={<ProtectedRoute component={ViewAttendanceRosterPage} />}
        />
        <Route
          path={routes.USER_TABLE_RACK_MAPPING.VIEW}
          element={<ProtectedRoute component={ViewUserTableRackMappingPage} />}
        />
        <Route
          path={routes.USER_TABLE_RACK_MAPPING.RACK_USERS}
          element={<ProtectedRoute component={RackUsersMappingPage} />}
        />
        <Route
          path={routes.DELIVERY_SERVICES.LOGIN_QR}
          element={<ProtectedRoute component={DeliveryLoginQRPage} />}
        />
        <Route
          path={routes.PO.DISPATCH_INVOICE}
          element={<ProtectedRoute component={DispatchInvoicePage} />}
        />
        <Route
          path={routes.PLATFORM_CONFIGS.ALL}
          element={<ProtectedRoute component={PlatformConfigListingPage} />}
        />
        <Route
          path={routes.PLATFORM_CONFIGS.CREATE}
          element={<ProtectedRoute component={PlatformConfigCreatePage} />}
        />
        <Route
          path={routes.PLATFORM_CONFIGS.DETAIL}
          element={<ProtectedRoute component={PlatformConfigDetailPage} />}
        />
      </Route>
      {/**
       * Lazy Loaded Routes END
       */}

      <Route element={<LoggedOutLayout />}>
        <Route path={routes.LOGIN} element={<LoginPage />} />
        <Route path={routes.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route path={routes.WAREHOUSE_SELECTION} element={<WarehouseSelectionPage />} />
      </Route>
    </Routes>
  </Suspense>
);
